<template>
  <div>
    <div
      class="row"
      :class="isMobile && 'box-sizing availability-calendar-day-main'"
    >
      <div class="d-flex w-100" :class="isMobile && 'scroll-h'">
        <calendar-return
          class="col-1"
          :is-day-selected="!!selectedDay"
          @return="onReturnSelection"
        />
        <div class="d-flex scroll-h">
          <calendar-day
            v-for="day in filterDays"
            :key="day.id"
            class="col"
            :class="isMobile && 'scrollable'"
            :day="day"
            :is-mobile="isMobile"
            :selected="day.id === (selectedDay && selectedDay.id)"
            @select="onSelectDay"
          />
        </div>
      </div>

      <div
        id="availability-calendar-container"
        class="col-12 calendar-container px-0"
        :class="[isMobile && 'p-0', editMode && 'border-dashed-orange']"
      >
        <div
          v-for="(hour, key) in hours"
          :key="hour.id"
          class="d-flex w-100"
          :class="isMobile && 'scroll-h'"
        >
          <calendar-hour
            :id="`calendar-hour-${key}`"
            :ref="`calendar-hour-${key}`"
            class="col-1"
            :hour="hour"
            :is-mobile="isMobile"
          />
          <div class="d-flex w-100" :class="isMobile && 'scroll-h'">
            <div
              v-for="day in filterDays"
              :key="day.id"
              class="col px-0 d-flex flex-column"
            >
              <div v-for="q in quaters" :key="`cell-${day.id}-${hour.id}-${q}`">
                <calendar-quater
                  :ref="`quater-item-${day.id}-${hour.id}-${q}`"
                  :admission="admission"
                  :all-data="quaterData(q, day, hour)"
                  :day="day"
                  :edit-info="editInfo"
                  :edit-mode="editMode"
                  :filter="filter"
                  :hour="hour"
                  :is-admission-coordination="isAdmissionCoordination"
                  :is-coordination="isCoordination"
                  :is-mobile="isMobile"
                  :is-transfer="isTransfer"
                  :practitioner-id="practitionerId"
                  :quater="q"
                  :selected-day="selectedDay"
                  :space-list="spaceList"
                  @add-admission-available-space="onAddAdmissionAvailableSpace"
                  @add-available-space="onAddAvailableSpace"
                  @edit-admission="onEditAdmission"
                  @remove-admission="onRemoveAdmission"
                  @show-popper-state="onShowPopperState"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarReturn from './AvailabilityCalendarReturn.vue';
import CalendarDay from './AvailabilityCalendarDay.vue';
import CalendarHour from './AvailabilityCalendarHour.vue';
import CalendarQuater from './AvailabilityCalendarQuater.vue';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';
import moment from 'moment';
import 'moment/locale/es-do';
import alert from '@quisit/mipe-utils/mixins/alert.mixin';
import disciplineTypeCode from '@/utils/constants/disciplineTypeCode';
import storeMixin from '@/shared/mixins/storeGenerator';
import { removeScheduleAdmission as _removeScheduleAdmission } from '@/modules/shared/servicelocation.api';
import { modalityTypes } from '@/utils/constants/modalityTypes';

const MODALITIES = Object.freeze({ COMPLEMENTARY: 491 });

export default {
  name: 'AvailabilityCalendar',
  components: {
    CalendarReturn,
    CalendarDay,
    CalendarHour,
    CalendarQuater,
  },
  mixins: [alert, storeMixin],
  props: {
    practitionerId: { type: Number, default: 0 },
    days: {
      type: Array,
      default: () => [
        { id: 1, name: 'Lunes' },
        { id: 2, name: 'Martes' },
        { id: 3, name: 'Miércoles' },
        { id: 4, name: 'Jueves' },
        { id: 5, name: 'Viernes' },
        { id: 6, name: 'Sábado' },
        { id: 0, name: 'Domingo' },
      ],
    },
    hours: {
      type: Array,
      default: () => [
        { id: 7, name: '7 AM' },
        { id: 8, name: '8 AM' },
        { id: 9, name: '9 AM' },
        { id: 10, name: '10 AM' },
        { id: 11, name: '11 AM' },
        { id: 12, name: '12 PM' },
        { id: 13, name: '1 PM' },
        { id: 14, name: '2 PM' },
        { id: 15, name: '3 PM' },
        { id: 16, name: '4 PM' },
        { id: 17, name: '5 PM' },
        { id: 18, name: '6 PM' },
        { id: 19, name: '7 PM' },
      ],
    },
    // ahora son números (0,5,...,55)
    quaters: {
      type: Array,
      default: () => [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
    },
    data: { type: Array, default: () => [] },
    admission: { type: Object, default: () => null },
    filter: { type: Object, default: () => null },
    editMode: { type: Boolean, default: false },
    specialist: { type: Object, default: () => null },
    editInfo: { type: Object, default: () => null },
    isAdmissionCoordination: { type: Boolean, default: false },
    isCoordination: { type: Boolean, default: false },
    isTransfer: { type: Boolean, default: false },
  },
  data: () => ({
    selectedDay: null,
    spaceList: [],
    // índice O(1) -> key: `${day}-${hour}-${quater}`
    scheduleIndex: new Map(),
  }),
  computed: {
    ...mapGetters(appModuleName, { isMobile: 'getIsMobileDensity' }),
    filterDays() {
      if (!this.selectedDay) return this.days;
      return this.days.filter((x) => x.id === this.selectedDay.id);
    },
    quaterData() {
      return (quater, day, hour) => {
        if (!day) return { scheduleId: 0, type: 0, data: [] };
        const key = `${day.id}-${hour.id}-${quater}`;
        const schedule = this.scheduleIndex.get(key);
        if (!schedule) return { scheduleId: 0, type: 0, data: [] };

        // normalización rápida para el quater
        const data =
          schedule.admissions?.map((a) => ({
            ...a,
            durationMinutes: a.duration?.split(' ')[0],
            timeStart: schedule.timeStart,
            scheduleId: schedule.id,
          })) ?? [];

        return {
          scheduleId: schedule.id,
          type: schedule.typeSpace ?? 0,
          data,
        };
      };
    },
  },
  watch: {
    data: {
      handler(newVal) {
        this.spaceList = Array.isArray(newVal) ? newVal : [];
        this.rebuildIndex();
      },
      immediate: true,
    },
  },
  mounted() {
    this.syncScroll();
  },
  methods: {
    // --- Indexa todos los schedules en un Map O(1) por celda ---
    rebuildIndex() {
      this.scheduleIndex.clear();
      if (!Array.isArray(this.spaceList) || !this.spaceList.length) return;

      for (const s of this.spaceList) {
        const day = s.dayOfWeek;
        const base = this.getStartDateOfWeek(day);
        const sh = s.timeStart?.value?.hours ?? s.timeStart?.hours;
        const sm = s.timeStart?.value?.minutes ?? s.timeStart?.minutes;
        const eh = s.timeEnd?.value?.hours ?? s.timeEnd?.hours;
        const em = s.timeEnd?.value?.minutes ?? s.timeEnd?.minutes;

        if (sh == null || sm == null || eh == null || em == null) continue;

        const start = base.clone().set({ hour: sh, minute: sm, second: 0 });
        const end = base.clone().set({ hour: eh, minute: em, second: 0 });

        // marcamos cada 15 días de 5 minutos en [start, end)
        for (
          let cur = start.clone();
          cur.isBefore(end);
          cur.add(5, 'minutes')
        ) {
          const key = `${day}-${cur.hour()}-${cur.minute()}`;
          // si hay colisiones, esogemos  el primero
          if (!this.scheduleIndex.has(key)) this.scheduleIndex.set(key, s);
        }
      }
    },

    onSelectDay(day) {
      this.selectedDay = day;
      this.$emit('select-day', day);
    },
    onReturnSelection() {
      this.selectedDay = null;
      this.$emit('select-day', null);
    },

    onAddAvailableSpace(item) {
      this.$emit('add-available-space', item);
    },
    onShowPopperState(state) {
      this.$emit('show-popper-state', state);
    },

    // scroll horizontal sincronizado
    syncScroll() {
      const scrollers = document.querySelectorAll('.scroll-h');
      scrollers.forEach((div) => {
        div.addEventListener('scroll', (e) => {
          scrollers.forEach((o) => {
            if (o !== e.target) o.scrollLeft = e.target.scrollLeft;
          });
        });
      });
    },

    // *** FIX domingo (id=0) con isoWeek ***
    getStartDateOfWeek(dayOfWeek) {
      const idx = dayOfWeek === 0 ? 7 : dayOfWeek; // 1..7
      return moment()
        .startOf('isoWeek')
        .add(idx - 1, 'days');
    },

    onAddAdmissionAvailableSpace(item) {
      const isInterfering = this.validInterferationBetweenSpaces(item);
      if (isInterfering) {
        this.ShowToast(
          'Error',
          'No es posible coordinar el servicio ya que hay un espacio coordinado para el horario seleccionado.',
          'error'
        );
        return;
      }
      this.$emit('add-admission-available-space', item);
    },

    validInterferationBetweenSpaces(space) {
      const serviceLocationId = this.filter?.locationService?.id;
      const locationGroup = space.data.filter(
        ({ locationId }) => locationId === serviceLocationId
      );
      if (locationGroup.length) {
        const studentIsPartOfTheGroup = locationGroup.some(
          ({ studentSieId: id }) => id === this.admission.studentSieId
        );
        if (!studentIsPartOfTheGroup) return false;
      }
      const currentStudentSpaces = this.spaceList
        .filter(({ dayOfWeek }) => dayOfWeek === space.day.id)
        .map(({ admissions, timeStart }) => {
          admissions =
            this.practitionerId == 0
              ? admissions
              : admissions.filter(
                  (x) => x.practitionerId == this.practitionerId
                );
          return admissions.map(
            ({
              durationMinutes,
              companyId,
              disciplineTypeId,
              municipalityId,
              practitionerId,
              locationId,
              studentSieId,
              admissionId,
            }) => {
              const { hours, minutes } = timeStart;
              const startMoment = moment(`${hours}:${minutes}`, 'h:mm');
              const startDate = startMoment.clone();
              const endDate = startMoment.add(
                Number(durationMinutes),
                'minutes'
              );
              return {
                startDate,
                endDate,
                companyId,
                disciplineTypeId,
                municipalityId,
                practitionerId,
                locationId,
                studentSieId,
                admissionId,
              };
            }
          );
        })
        .reduce((sum, val) => sum.concat(val), []);
      const newSpaceMoment = moment(`${space.hour.id}:${space.quater}`, 'h:mm');
      const startDate = newSpaceMoment.clone();
      const endDate = newSpaceMoment.add(Number(space.duration), 'minutes');
      const result = currentStudentSpaces.some((x) => {
        if (startDate.isSame(x.startDate) && x.locationId == serviceLocationId)
          return true;
        if (endDate.isSame(x.endDate) && x.locationId == serviceLocationId)
          return true;
        if (
          startDate.isBetween(x.startDate, x.endDate) &&
          x.locationId == serviceLocationId
        )
          return true;
        if (
          endDate.isBetween(x.startDate, x.endDate) &&
          x.locationId == serviceLocationId
        )
          return true;
        return false;
      });
      return result;
    },

    async moveAdmission(e, scheduleId) {
      const { item, to } = e;
      const src = item.__vue__;
      const isAvailable = to.__vue__.$children[0].isAvailable;
      if (!src.isAvailable || src.isInOtherCompany || src.isInOtherLocation)
        return;
      if (!isAvailable) {
        this.ShowToast(
          'Error',
          'No es posible coordinar el servicio ya que el horario no esta disponible.',
          'error'
        );
        this.$emit('reaload-data');
        return;
      }
      if (src.data.length > 0) {
        const studentsName = src.data.map((x) => x.studentName).join(', ');
        const refName = `quater-item-${to.firstChild.id}`;
        const target = this.$refs[refName]?.[0];
        if (!target) return;

        if (
          target.data.some((x) => x.modalityId != src.data[0].modalityId) &&
          this.admission.modalityId !== MODALITIES.COMPLEMENTARY
        ) {
          this.ShowToast(
            'Error',
            'Todos los servicios deben estar en la misma modalidad.',
            'error'
          );
          return;
        }
        if (target.data.some((x) => x.durationId != src.data[0].durationId)) {
          this.ShowToast(
            'Error',
            'Los servicios tienen que ser de la misma duración para poder ser coordinados en el mismo espacio.',
            'error'
          );
          return;
        }

        const ocupacionalServices = target.allData.data.filter(
          (item) =>
            item.disciplineTypeId === disciplineTypeCode.TerapiaOcupacional &&
            (item.practitionerId == this.practitionerId ||
              (item.practitionerId === null && this.practitionerId === 0))
        );
        const otherServices = target.allData.data.filter(
          (item) =>
            item.disciplineTypeId !== disciplineTypeCode.TerapiaOcupacional &&
            (item.practitionerId == this.practitionerId ||
              (item.practitionerId === null && this.practitionerId === 0))
        );
        const ocupacionalOccurrences = ocupacionalServices.reduce(
          (acc, item) => {
            const key = `${item.disciplineTypeId}-${item.practitionerId ?? 0}`;
            acc[key] = (acc[key] || 0) + 1;
            return acc;
          },
          {}
        );
        const otherOccurrences = otherServices.reduce((acc, item) => {
          const key = `${item.disciplineTypeId}-${item.practitionerId ?? 0}`;
          acc[key] = (acc[key] || 0) + 1;
          return acc;
        }, {});
        const hasReachedMaxServices =
          Object.values(ocupacionalOccurrences).some((c) => c === 5) ||
          Object.values(otherOccurrences).some((c) => c === 4);
        if (hasReachedMaxServices) {
          this.ShowToast(
            'Error',
            'No es posible coordinar el servicio ya que el grupo cuenta con el máximo de estudiantes.',
            'error'
          );
          return;
        }

        const inSameDay = this.spaceList
          .filter(({ dayOfWeek }) => dayOfWeek === target.day.id)
          .filter(
            ({ admissions: a }) =>
              a.length &&
              a.some(({ studentSieId: id }) =>
                src.data.some((d) => d.studentSieId === id)
              )
          );
        if (inSameDay.length) {
          this.ShowToast(
            'Error',
            'No se permite coordinar mas de un espacio el mismo dia para el servicio del estudiante.',
            'error'
          );
          return;
        }

        const payload = src.data.map((e) => ({
          admissionId: e.admissionId,
          oldScheduleId: scheduleId,
          newScheduleId: target.scheduleId,
        }));
        if (!payload.every((e) => e.oldScheduleId == e.newScheduleId)) {
          const hourDescription =
            target.hour.id > 11
              ? `${
                  target.hour.id == 12 ? target.hour.id : target.hour.id - 12
                }:${target.quater} PM`
              : `${target.hour.id}:${
                  target.quater == 0 ? '00' : target.quater
                } AM`;
          const answer = await this.ShowCancelModal(
            'Confirmación',
            `¿Está seguro(a) que desea mover a ${studentsName} al ${target.day.name} a las ${hourDescription}?`,
            'Sí',
            'No'
          );
          if (!answer) return;
          this.$emit('move-admission', payload);
        }
      }
    },

    onEditAdmission(item) {
      const edit = 1;
      this.$emit('edit-admission', {
        admissionId: item.admissionId,
        edit,
        id: item.id,
        specialistId: this.specialist.id,
        scheduleId: item.scheduleId,
        practitionerId: item.practitionerId,
        studentName: item.studentName,
        modalityId: item.modalityId,
      });
    },

    onRemoveAdmission(item) {
      if (modalityTypes.IndividualTherapy == item.modalityId) {
        this.handleRemoveAdmission(item);
        return;
      }
      const edit = 1;
      this.$emit('remove-admission', {
        admissionId: item.admissionId,
        edit,
        id: item.id,
        specialistId: this.specialist.id,
        scheduleId: item.scheduleId,
        practitionerId: item.practitionerId,
        studentName: item.studentName,
        modalityId: item.modalityId,
      });
    },

    async handleRemoveAdmission(item) {
      try {
        const confirmation = await this.ShowCancelModal(
          'Atención',
          `¿Desea Eliminar el espacio de la sesión del estudiante ${item.studentName}?`,
          'Sí',
          'No'
        );
        if (!confirmation) return;
        const payload = {
          oldScheduleId: item.scheduleId,
          admissionId: item.admissionId,
          isRemoveModeInGroup: false,
        };
        await _removeScheduleAdmission(payload);
        this.ShowToast(
          'Proceso Exitoso',
          'Admision removida exitosamente',
          'success'
        );
        this.$emit('refresh-after-remove');
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.calendar-container {
  max-height: 790px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
}

#scrollable-columns #fixed-column {
  max-height: 790px;
  height: 790px;
  & * {
    max-height: 790px;
    height: 790px;
  }
}

.calendar-container::-webkit-scrollbar {
  width: 5px;
  background: #f1f1f1;
}
.calendar-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 25px;
}

/* Scroll horizontal */
.scroll-h {
  width: 100%;
  overflow-x: scroll;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  box-sizing: border-box;
}
.scroll-h::-webkit-scrollbar {
  display: none;
}

.box-sizing {
  box-sizing: border-box;
  width: 100vw;
  padding: 10px;
}

.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
  overflow-x: scroll;
}
.scrollable:not(.fixed) {
  overflow-x: hidden;
}

.availability-calendar-day-main.fixed,
.availability-calendar-quater-main.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
  overflow-x: scroll;
}

.overflow-scroll {
  overflow-x: scroll;
}
.overflow-scroll::-webkit-scrollbar {
  display: none;
}

.border-dashed-orange {
  border: 3px dashed #ff7059 !important;
}
</style>
